import { Capacitor } from '@capacitor/core';

export type Platform = 'web' | 'ios' | 'android';

/**
 * Narrowing here turns typos like `=== 'iOS'` into compile errors instead of silent falses.
 */
export const getPlatform = (): Platform => Capacitor.getPlatform() as Platform;

export const isWeb = (): boolean => getPlatform() === 'web';
export const isNative = (): boolean => getPlatform() !== 'web';
export const isIOS = (): boolean => getPlatform() === 'ios';
export const isAndroid = (): boolean => getPlatform() === 'android';
